import { createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-490d3c46")

_pushScopeId("data-v-490d3c46")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Read More")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Hide")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("section", {
    class: ["module", [ _ctx.module.type, { 'is-collapsed': _ctx.isCollapsed } ]]
  }, [
    _createVNode("div", {
      innerHTML: _ctx.module.moduleBody
    }, null, 8, ["innerHTML"]),
    (_ctx.module.moduleIsCollapsible)
      ? (_openBlock(), _createBlock("button", {
          key: 0,
          class: "btn collapse-btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCollapseToggleBtnClick && _ctx.onCollapseToggleBtnClick(...args)))
        }, [
          (_ctx.isCollapsed)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _hoisted_1
              ], 64))
            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _hoisted_2
              ], 64))
        ]))
      : _createCommentVNode("", true)
  ], 2))
})